module.exports = fox._r("images/promo/tutorial/12.png", __webpack_public_path__ + "_/common/images/promo/tutorial/12.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/12.png
// module id = 660
// module chunks = 2